import script from "./SurveyDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyDetail.vue?vue&type=script&setup=true&lang=js"

import "./SurveyDetail.vue?vue&type=style&index=0&id=46b9004d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46b9004d"]])

export default __exports__